import IStepSevenModel from './IStepSevenModel';

const StepSevenModelInitialState: IStepSevenModel = {
  address: null,
  city: null,
  codePosti: null,
  mobile: null,
  province: null,
};

export default StepSevenModelInitialState;
